import getLocalWishlist from '../utils/getLocalWishlist';
import SELECTORS from '../utils/vars/SELECTORS';

if (!customElements.get('wishlist-page')) {
  class WishlistPage extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupGrid();
      this.setupEventListeners();
    }

    setupEventListeners() {
      document.addEventListener('wishlist:updated', this.setupGrid.bind(this));
    }

    get wishlistGrid() {
      return this.querySelector(SELECTORS.WISHLIST_GRID);
    }

    async setupGrid() {
      if (!this.wishlistGrid) return;
      const wishlist = getLocalWishlist();
      const requests = wishlist.map(this.fetchProductCardHTML);
      const responses = await Promise.all(requests);

      const wishlistProductCards = responses.join('');
      this.renderWishlistContent(wishlistProductCards);
    }

    renderWishlistContent(wishlistProductCards) {
      const wishlistEmpty = this.querySelector(SELECTORS.WISHLIST_EMPTY);
      const wishlistNotEmpty = this.querySelector(SELECTORS.WISHLIST_NOT_EMPTY);
      const wishlistGridWrapper = this.querySelector(SELECTORS.WISHLIST_GRID_WRAPPER);

      if (wishlistProductCards) {
        if (wishlistEmpty) wishlistEmpty.classList.add('hidden');
        if (wishlistNotEmpty) wishlistNotEmpty.classList.remove('hidden');
        if (wishlistGridWrapper) wishlistGridWrapper.classList.remove('hidden');
        this.wishlistGrid.innerHTML = wishlistProductCards;
      } else {
        if (wishlistEmpty) wishlistEmpty.classList.remove('hidden');
        if (wishlistNotEmpty) wishlistNotEmpty.classList.add('hidden');
        if (wishlistGridWrapper) wishlistGridWrapper.classList.add('hidden');
        this.wishlistGrid.innerHTML = '';
      }

      const event = new CustomEvent('wishlist:render-content', {});
      document.dispatchEvent(event);
    }

    async fetchProductCardHTML(handle, index) {
      const productTileTemplateUrl = `/products/${handle}?view=product-grid-item`;

      try {
        const res = await fetch(productTileTemplateUrl);
        const res_2 = await res.text();
        const text = res_2;
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');
        const productCard = htmlDocument.documentElement.querySelector('[data-product-block]');

        if (productCard) return productCard.outerHTML;
      } catch (err) {
        return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
      }
    }
  }
  customElements.define('wishlist-page', WishlistPage);
}
